(() => {
  angular
    .module('gm.common.crypto', [])
    .factory('GmyCrypto', GmyCrypto);

  function GmyCrypto(
    $window
  ) {
    'ngInject';

    return {
      truncatedSHA512
    };

    function truncatedSHA512(text) {
      return $window.CryptoJS.SHA512(text).toString($window.CryptoJS.enc.Hex).substr(0, 32);
    }
  }
})();
